

document.addEventListener('LensAdvizor:init:complete', function(){
 
  if ($('.status_checkbox_preorder').length > 0 && $(".status_preorder").is(':visible') == true) {
  $('.variant-inventory-checkbox input[type="checkbox"]').attr("disabled","disabled");
    
    // If visible, keep button disabled
    $('#la-select-lenses-btn')
      .attr('data-loaded', 'false')
      .css({
        'pointer-events': 'none',
        'opacity': '0.6',
        'cursor': 'not-allowed'
      });
       
  } else {
    // If hidden, make button interactive
    $('#la-select-lenses-btn')
      .attr('data-loaded', 'true')
      .css({
        'pointer-events': 'auto',
        'opacity': '1',
        'cursor': 'pointer'
      });
    
  }
  
});
$(document).ready(function() {
   setTimeout(function(){
      // Initialize button as non-interactive
  if ($('.status_checkbox_preorder').length > 0 && $(".status_preorder").is(':visible') == true) {
  $('.variant-inventory-checkbox input[type="checkbox"]').attr("disabled","disabled");
    
    // If visible, keep button disabled
    $('#la-select-lenses-btn')
      .attr('data-loaded', 'false')
      .css({
        'pointer-events': 'none',
        'opacity': '0.6',
        'cursor': 'not-allowed'
      });
    if( $('#la-select-lenses-btn').length == 0){
      $("#AddToCart.PreorderExist").attr("disabled","disabled");
    }
    
  } else {
    // If hidden, make button interactive
    $('#la-select-lenses-btn')
      .attr('data-loaded', 'true')
      .css({
        'pointer-events': 'auto',
        'opacity': '1',
        'cursor': 'pointer'
      });
    if( $('#la-select-lenses-btn').length == 0){
      $("#AddToCart.PreorderExist").removeAttr("disabled");
    }
  }
   },500);
 
  
  $("#toggleCheckbox").on("click", function() {
    var $checkbox = $('.variant-inventory-checkbox input[type="checkbox"]');
    var $lensBtn = $('#la-select-lenses-btn');
    var attr = $('.variant-inventory-checkbox input[type="checkbox"]').attr('disabled');
    // Toggle checkbox state
   if (typeof attr !== 'undefined' && attr !== false) {
     $checkbox.removeAttr("disabled","disabled");
      var isActive = true;
      if( $('#la-select-lenses-btn').length == 0){
      $("#AddToCart.PreorderExist").removeAttr("disabled");
    }
     
    }else{
        $checkbox.attr("disabled","disabled");
      var isActive = false;    
      if( $('#la-select-lenses-btn').length == 0){
      $("#AddToCart.PreorderExist").attr("disabled","disabled");
    }
    }
     // Update button state   
    $lensBtn
      .attr('data-loaded', isActive)
      .css({
        'pointer-events': isActive ? 'auto' : 'none',
        'opacity': isActive ? '1' : '0.6',
        'cursor': isActive ? 'pointer' : 'not-allowed'
      });
    
    console.log(
      isActive 
        ? "Checkbox disabled (button inactive)" 
        : "Checkbox enabled (button active)"
    );
  });

  
  $('.tabs-header-btn').click(function(){
    $('.arrow-tab').html('<i class="fas fa-caret-right"></i>');
    if ($(this).parents('.tabs').find('.tabs-content-custom').hasClass("tab-custom-current")){
      $(this).find('.arrow-tab').html('<i class="fas fa-caret-right"></i>');
      $(this).parents('.tabs').find('.tabs-content-custom').toggleClass('tab-custom-current');
    }else{
      $('.tabs-inner').find('.tab-custom-current').removeClass('tab-custom-current');
      if($(this).find('.arrow-tab i').hasClass("fa-caret-right")){
        $(this).find('.arrow-tab').html('<i class="fas fa-caret-down"></i>');
      }else{
        $(this).find('.arrow-tab').html('<i class="fas fa-caret-right"></i>');
      }
      $(this).parents('.tabs').find('.tabs-content-custom').toggleClass('tab-custom-current');

    }
  });
  
  $('.collection-description-details-button').click(function(){
  $('.description-content-inner').slideToggle();
   $(this).toggleClass("collection-description-details-button-changed");
   var textchange = $(this).hasClass("collection-description-details-button-changed");
    if(textchange == true){
     $(this).text("(− read less)")
    }
    else{
     $(this).text("(+ brand details)")
    } 
  });
  
  if ($(window).width() < 488) {
    $('.show-less-fiter').hide();
    var a = 1;
    $('.tags-filter-holder-block').each(function(){
      if(a <= 2){
      $(this).addClass('visible-tag-filter-box');
      }
      a = a + 1;
    });
    if (a > 2){
    $('.filter-toggle-btn-holder').show();
    }
    $('.show-more-fiter').click(function(){
      $(this).hide();
      $('.show-less-fiter').show();
       $('.tags-filter-holder-block').addClass('visible-tag-filter-box');
    });

    $('.show-less-fiter').click(function(){
       $('.tags-filter-holder-block').removeClass('visible-tag-filter-box');
      $(this).hide();
      $('.show-more-fiter').show();
      var b = 1;
      $('.tags-filter-holder-block').each(function(){
        if(b <= 2){
          $(this).addClass('visible-tag-filter-box');
        }
        b = b + 1;
      });
    });

  }

// pdp app image height
  // $(window).on('load resize scroll', function(){
  //     var mainHeightImg = $('.before-after-slider.horizontal .before-after-slider-image.before img').height();
  //     $('.before-after-slider.horizontal').css('min-height', mainHeightImg);
  // });

  
  
});

// pdp price match form popup


// $(document).ready(function() {
//   $(".set > a").on("click", function() {
//     if ($(this).hasClass("active")) {
//       $(this).removeClass("active");
//       $(this)
//       .siblings(".content")
//       .slideUp(200);
//       $(".set > a i")
//       .removeClass("fa-minus")
//       .addClass("fa-plus");
//     } else {
//       $(".set > a i")
//       .removeClass("fa-minus")
//       .addClass("fa-plus");
//       $(this)
//       .find("i")
//       .removeClass("fa-plus")
//       .addClass("fa-minus");
//       $(".set > a").removeClass("active");
//       $(this).addClass("active");
//       $(".content").slideUp(200);
//       $(this)
//       .siblings(".content")
//       .slideDown(200);
//     }
//   });
// });


$(document).ready(function() {
 // console.log('eeffjkej');
  setTimeout(function(){ 
 //   console.log('dddd');
    jQuery('.wlc-standard .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.wlc-silver .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.wlc-gold .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.wlc-platinum .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.kodak-standard .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.kodak-silver .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.kodak-gold .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.kodak-platinum .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.zeiss-standard .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.zeiss-silver .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.zeiss-gold .admin__field-label').wrap("<td class='price-deets'></td>");
    jQuery('.zeiss-platinum .admin__field-label').wrap("<td class='price-deets'></td>");
  }, 9000);
  
  /******** ATC hide/show ********/

  
  });